module.exports = __webpack_public_path__ + "static/img/dominos-screen3-2x.bce442f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-screen3-2x.jpg
// module id = M2lO
// module chunks = 0